import * as X from "react";
import Ir, { forwardRef as wa, useContext as Ma, createContext as Aa, useEffect as Oa } from "react";
var er = { exports: {} }, he = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mr;
function Da() {
  if (Mr)
    return he;
  Mr = 1;
  var e = Ir, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function d(l, f, h) {
    var p, b = {}, P = null, F = null;
    h !== void 0 && (P = "" + h), f.key !== void 0 && (P = "" + f.key), f.ref !== void 0 && (F = f.ref);
    for (p in f)
      n.call(f, p) && !c.hasOwnProperty(p) && (b[p] = f[p]);
    if (l && l.defaultProps)
      for (p in f = l.defaultProps, f)
        b[p] === void 0 && (b[p] = f[p]);
    return { $$typeof: r, type: l, key: P, ref: F, props: b, _owner: o.current };
  }
  return he.Fragment = t, he.jsx = d, he.jsxs = d, he;
}
var be = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Ca() {
  return Ar || (Ar = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ir, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), d = Symbol.for("react.provider"), l = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), b = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), F = Symbol.for("react.offscreen"), C = Symbol.iterator, g = "@@iterator";
    function J(a) {
      if (a === null || typeof a != "object")
        return null;
      var i = C && a[C] || a[g];
      return typeof i == "function" ? i : null;
    }
    var k = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(a) {
      {
        for (var i = arguments.length, u = new Array(i > 1 ? i - 1 : 0), m = 1; m < i; m++)
          u[m - 1] = arguments[m];
        D("error", a, u);
      }
    }
    function D(a, i, u) {
      {
        var m = k.ReactDebugCurrentFrame, x = m.getStackAddendum();
        x !== "" && (i += "%s", u = u.concat([x]));
        var _ = u.map(function(S) {
          return String(S);
        });
        _.unshift("Warning: " + i), Function.prototype.apply.call(console[a], console, _);
      }
    }
    var R = !1, s = !1, L = !1, O = !1, We = !1, xe;
    xe = Symbol.for("react.module.reference");
    function Ve(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === n || a === c || We || a === o || a === h || a === p || O || a === F || R || s || L || typeof a == "object" && a !== null && (a.$$typeof === P || a.$$typeof === b || a.$$typeof === d || a.$$typeof === l || a.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === xe || a.getModuleId !== void 0));
    }
    function Ue(a, i, u) {
      var m = a.displayName;
      if (m)
        return m;
      var x = i.displayName || i.name || "";
      return x !== "" ? u + "(" + x + ")" : u;
    }
    function Ee(a) {
      return a.displayName || "Context";
    }
    function Y(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case c:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case l:
            var i = a;
            return Ee(i) + ".Consumer";
          case d:
            var u = a;
            return Ee(u._context) + ".Provider";
          case f:
            return Ue(a, a.render, "ForwardRef");
          case b:
            var m = a.displayName || null;
            return m !== null ? m : Y(a.type) || "Memo";
          case P: {
            var x = a, _ = x._payload, S = x._init;
            try {
              return Y(S(_));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, Q = 0, we, Me, ue, Ae, de, Oe, De;
    function Ce() {
    }
    Ce.__reactDisabledLog = !0;
    function Ke() {
      {
        if (Q === 0) {
          we = console.log, Me = console.info, ue = console.warn, Ae = console.error, de = console.group, Oe = console.groupCollapsed, De = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: Ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        Q++;
      }
    }
    function Ye() {
      {
        if (Q--, Q === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, a, {
              value: we
            }),
            info: q({}, a, {
              value: Me
            }),
            warn: q({}, a, {
              value: ue
            }),
            error: q({}, a, {
              value: Ae
            }),
            group: q({}, a, {
              value: de
            }),
            groupCollapsed: q({}, a, {
              value: Oe
            }),
            groupEnd: q({}, a, {
              value: De
            })
          });
        }
        Q < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var le = k.ReactCurrentDispatcher, pe;
    function re(a, i, u) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (x) {
            var m = x.stack.trim().match(/\n( *(at )?)/);
            pe = m && m[1] || "";
          }
        return `
` + pe + a;
      }
    }
    var ye = !1, ae;
    {
      var Ge = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new Ge();
    }
    function y(a, i) {
      if (!a || ye)
        return "";
      {
        var u = ae.get(a);
        if (u !== void 0)
          return u;
      }
      var m;
      ye = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var _;
      _ = le.current, le.current = null, Ke();
      try {
        if (i) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (Z) {
              m = Z;
            }
            Reflect.construct(a, [], S);
          } else {
            try {
              S.call();
            } catch (Z) {
              m = Z;
            }
            a.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            m = Z;
          }
          a();
        }
      } catch (Z) {
        if (Z && m && typeof Z.stack == "string") {
          for (var v = Z.stack.split(`
`), W = m.stack.split(`
`), N = v.length - 1, j = W.length - 1; N >= 1 && j >= 0 && v[N] !== W[j]; )
            j--;
          for (; N >= 1 && j >= 0; N--, j--)
            if (v[N] !== W[j]) {
              if (N !== 1 || j !== 1)
                do
                  if (N--, j--, j < 0 || v[N] !== W[j]) {
                    var K = `
` + v[N].replace(" at new ", " at ");
                    return a.displayName && K.includes("<anonymous>") && (K = K.replace("<anonymous>", a.displayName)), typeof a == "function" && ae.set(a, K), K;
                  }
                while (N >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        ye = !1, le.current = _, Ye(), Error.prepareStackTrace = x;
      }
      var oe = a ? a.displayName || a.name : "", wr = oe ? re(oe) : "";
      return typeof a == "function" && ae.set(a, wr), wr;
    }
    function fe(a, i, u) {
      return y(a, !1);
    }
    function te(a) {
      var i = a.prototype;
      return !!(i && i.isReactComponent);
    }
    function ee(a, i, u) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return y(a, te(a));
      if (typeof a == "string")
        return re(a);
      switch (a) {
        case h:
          return re("Suspense");
        case p:
          return re("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case f:
            return fe(a.render);
          case b:
            return ee(a.type, i, u);
          case P: {
            var m = a, x = m._payload, _ = m._init;
            try {
              return ee(_(x), i, u);
            } catch {
            }
          }
        }
      return "";
    }
    var _e = Object.prototype.hasOwnProperty, yr = {}, fr = k.ReactDebugCurrentFrame;
    function Pe(a) {
      if (a) {
        var i = a._owner, u = ee(a.type, a._source, i ? i.type : null);
        fr.setExtraStackFrame(u);
      } else
        fr.setExtraStackFrame(null);
    }
    function oa(a, i, u, m, x) {
      {
        var _ = Function.call.bind(_e);
        for (var S in a)
          if (_(a, S)) {
            var v = void 0;
            try {
              if (typeof a[S] != "function") {
                var W = Error((m || "React class") + ": " + u + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              v = a[S](i, S, m, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (N) {
              v = N;
            }
            v && !(v instanceof Error) && (Pe(x), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", u, S, typeof v), Pe(null)), v instanceof Error && !(v.message in yr) && (yr[v.message] = !0, Pe(x), T("Failed %s type: %s", u, v.message), Pe(null));
          }
      }
    }
    var ia = Array.isArray;
    function He(a) {
      return ia(a);
    }
    function ca(a) {
      {
        var i = typeof Symbol == "function" && Symbol.toStringTag, u = i && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return u;
      }
    }
    function sa(a) {
      try {
        return mr(a), !1;
      } catch {
        return !0;
      }
    }
    function mr(a) {
      return "" + a;
    }
    function hr(a) {
      if (sa(a))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ca(a)), mr(a);
    }
    var me = k.ReactCurrentOwner, ua = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, br, Tr, Be;
    Be = {};
    function da(a) {
      if (_e.call(a, "ref")) {
        var i = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function la(a) {
      if (_e.call(a, "key")) {
        var i = Object.getOwnPropertyDescriptor(a, "key").get;
        if (i && i.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function pa(a, i) {
      if (typeof a.ref == "string" && me.current && i && me.current.stateNode !== i) {
        var u = Y(me.current.type);
        Be[u] || (T('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(me.current.type), a.ref), Be[u] = !0);
      }
    }
    function ya(a, i) {
      {
        var u = function() {
          br || (br = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        u.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function fa(a, i) {
      {
        var u = function() {
          Tr || (Tr = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
        };
        u.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var ma = function(a, i, u, m, x, _, S) {
      var v = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: a,
        key: i,
        ref: u,
        props: S,
        // Record the component responsible for creating this element.
        _owner: _
      };
      return v._store = {}, Object.defineProperty(v._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(v, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(v, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(v.props), Object.freeze(v)), v;
    };
    function ha(a, i, u, m, x) {
      {
        var _, S = {}, v = null, W = null;
        u !== void 0 && (hr(u), v = "" + u), la(i) && (hr(i.key), v = "" + i.key), da(i) && (W = i.ref, pa(i, x));
        for (_ in i)
          _e.call(i, _) && !ua.hasOwnProperty(_) && (S[_] = i[_]);
        if (a && a.defaultProps) {
          var N = a.defaultProps;
          for (_ in N)
            S[_] === void 0 && (S[_] = N[_]);
        }
        if (v || W) {
          var j = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          v && ya(S, j), W && fa(S, j);
        }
        return ma(a, v, W, x, m, me.current, S);
      }
    }
    var qe = k.ReactCurrentOwner, vr = k.ReactDebugCurrentFrame;
    function ne(a) {
      if (a) {
        var i = a._owner, u = ee(a.type, a._source, i ? i.type : null);
        vr.setExtraStackFrame(u);
      } else
        vr.setExtraStackFrame(null);
    }
    var Ze;
    Ze = !1;
    function Xe(a) {
      return typeof a == "object" && a !== null && a.$$typeof === r;
    }
    function gr() {
      {
        if (qe.current) {
          var a = Y(qe.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function ba(a) {
      {
        if (a !== void 0) {
          var i = a.fileName.replace(/^.*[\\\/]/, ""), u = a.lineNumber;
          return `

Check your code at ` + i + ":" + u + ".";
        }
        return "";
      }
    }
    var Sr = {};
    function Ta(a) {
      {
        var i = gr();
        if (!i) {
          var u = typeof a == "string" ? a : a.displayName || a.name;
          u && (i = `

Check the top-level render call using <` + u + ">.");
        }
        return i;
      }
    }
    function kr(a, i) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var u = Ta(i);
        if (Sr[u])
          return;
        Sr[u] = !0;
        var m = "";
        a && a._owner && a._owner !== qe.current && (m = " It was passed a child from " + Y(a._owner.type) + "."), ne(a), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, m), ne(null);
      }
    }
    function xr(a, i) {
      {
        if (typeof a != "object")
          return;
        if (He(a))
          for (var u = 0; u < a.length; u++) {
            var m = a[u];
            Xe(m) && kr(m, i);
          }
        else if (Xe(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var x = J(a);
          if (typeof x == "function" && x !== a.entries)
            for (var _ = x.call(a), S; !(S = _.next()).done; )
              Xe(S.value) && kr(S.value, i);
        }
      }
    }
    function va(a) {
      {
        var i = a.type;
        if (i == null || typeof i == "string")
          return;
        var u;
        if (typeof i == "function")
          u = i.propTypes;
        else if (typeof i == "object" && (i.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        i.$$typeof === b))
          u = i.propTypes;
        else
          return;
        if (u) {
          var m = Y(i);
          oa(u, a.props, "prop", m, a);
        } else if (i.PropTypes !== void 0 && !Ze) {
          Ze = !0;
          var x = Y(i);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ga(a) {
      {
        for (var i = Object.keys(a.props), u = 0; u < i.length; u++) {
          var m = i[u];
          if (m !== "children" && m !== "key") {
            ne(a), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ne(null);
            break;
          }
        }
        a.ref !== null && (ne(a), T("Invalid attribute `ref` supplied to `React.Fragment`."), ne(null));
      }
    }
    function Er(a, i, u, m, x, _) {
      {
        var S = Ve(a);
        if (!S) {
          var v = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (v += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = ba(x);
          W ? v += W : v += gr();
          var N;
          a === null ? N = "null" : He(a) ? N = "array" : a !== void 0 && a.$$typeof === r ? (N = "<" + (Y(a.type) || "Unknown") + " />", v = " Did you accidentally export a JSX literal instead of a component?") : N = typeof a, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", N, v);
        }
        var j = ha(a, i, u, x, _);
        if (j == null)
          return j;
        if (S) {
          var K = i.children;
          if (K !== void 0)
            if (m)
              if (He(K)) {
                for (var oe = 0; oe < K.length; oe++)
                  xr(K[oe], a);
                Object.freeze && Object.freeze(K);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xr(K, a);
        }
        return a === n ? ga(j) : va(j), j;
      }
    }
    function Sa(a, i, u) {
      return Er(a, i, u, !0);
    }
    function ka(a, i, u) {
      return Er(a, i, u, !1);
    }
    var xa = ka, Ea = Sa;
    be.Fragment = n, be.jsx = xa, be.jsxs = Ea;
  }()), be;
}
process.env.NODE_ENV === "production" ? er.exports = Da() : er.exports = Ca();
var Or = er.exports;
function _a(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Pa(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Fa = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(o) {
      var c;
      n.tags.length === 0 ? n.insertionPoint ? c = n.insertionPoint.nextSibling : n.prepend ? c = n.container.firstChild : c = n.before : c = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, c), n.tags.push(o);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Pa(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var c = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      c && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !c;
    }
    if (this.isSpeedy) {
      var d = _a(o);
      try {
        d.insertRule(n, d.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), I = "-ms-", je = "-moz-", E = "-webkit-", ir = "comm", cr = "rule", sr = "decl", Ra = "@import", Wr = "@keyframes", Na = "@layer", Ja = Math.abs, Le = String.fromCharCode, ja = Object.assign;
function za(e, r) {
  return $(e, 0) ^ 45 ? (((r << 2 ^ $(e, 0)) << 2 ^ $(e, 1)) << 2 ^ $(e, 2)) << 2 ^ $(e, 3) : 0;
}
function Vr(e) {
  return e.trim();
}
function La(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function w(e, r, t) {
  return e.replace(r, t);
}
function rr(e, r) {
  return e.indexOf(r);
}
function $(e, r) {
  return e.charCodeAt(r) | 0;
}
function ve(e, r, t) {
  return e.slice(r, t);
}
function H(e) {
  return e.length;
}
function ur(e) {
  return e.length;
}
function Fe(e, r) {
  return r.push(e), e;
}
function $a(e, r) {
  return e.map(r).join("");
}
var $e = 1, ce = 1, Ur = 0, V = 0, z = 0, se = "";
function Ie(e, r, t, n, o, c, d) {
  return { value: e, root: r, parent: t, type: n, props: o, children: c, line: $e, column: ce, length: d, return: "" };
}
function Te(e, r) {
  return ja(Ie("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Ia() {
  return z;
}
function Wa() {
  return z = V > 0 ? $(se, --V) : 0, ce--, z === 10 && (ce = 1, $e--), z;
}
function U() {
  return z = V < Ur ? $(se, V++) : 0, ce++, z === 10 && (ce = 1, $e++), z;
}
function B() {
  return $(se, V);
}
function Re() {
  return V;
}
function ke(e, r) {
  return ve(se, e, r);
}
function ge(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Kr(e) {
  return $e = ce = 1, Ur = H(se = e), V = 0, [];
}
function Yr(e) {
  return se = "", e;
}
function Ne(e) {
  return Vr(ke(V - 1, ar(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Va(e) {
  for (; (z = B()) && z < 33; )
    U();
  return ge(e) > 2 || ge(z) > 3 ? "" : " ";
}
function Ua(e, r) {
  for (; --r && U() && !(z < 48 || z > 102 || z > 57 && z < 65 || z > 70 && z < 97); )
    ;
  return ke(e, Re() + (r < 6 && B() == 32 && U() == 32));
}
function ar(e) {
  for (; U(); )
    switch (z) {
      case e:
        return V;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ar(z);
        break;
      case 40:
        e === 41 && ar(e);
        break;
      case 92:
        U();
        break;
    }
  return V;
}
function Ka(e, r) {
  for (; U() && e + z !== 47 + 10; )
    if (e + z === 42 + 42 && B() === 47)
      break;
  return "/*" + ke(r, V - 1) + "*" + Le(e === 47 ? e : U());
}
function Ya(e) {
  for (; !ge(B()); )
    U();
  return ke(e, V);
}
function Ga(e) {
  return Yr(Je("", null, null, null, [""], e = Kr(e), 0, [0], e));
}
function Je(e, r, t, n, o, c, d, l, f) {
  for (var h = 0, p = 0, b = d, P = 0, F = 0, C = 0, g = 1, J = 1, k = 1, T = 0, D = "", R = o, s = c, L = n, O = D; J; )
    switch (C = T, T = U()) {
      case 40:
        if (C != 108 && $(O, b - 1) == 58) {
          rr(O += w(Ne(T), "&", "&\f"), "&\f") != -1 && (k = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += Ne(T);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += Va(C);
        break;
      case 92:
        O += Ua(Re() - 1, 7);
        continue;
      case 47:
        switch (B()) {
          case 42:
          case 47:
            Fe(Ha(Ka(U(), Re()), r, t), f);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * g:
        l[h++] = H(O) * k;
      case 125 * g:
      case 59:
      case 0:
        switch (T) {
          case 0:
          case 125:
            J = 0;
          case 59 + p:
            k == -1 && (O = w(O, /\f/g, "")), F > 0 && H(O) - b && Fe(F > 32 ? Cr(O + ";", n, t, b - 1) : Cr(w(O, " ", "") + ";", n, t, b - 2), f);
            break;
          case 59:
            O += ";";
          default:
            if (Fe(L = Dr(O, r, t, h, p, o, l, D, R = [], s = [], b), c), T === 123)
              if (p === 0)
                Je(O, r, L, L, R, c, b, l, s);
              else
                switch (P === 99 && $(O, 3) === 110 ? 100 : P) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Je(e, L, L, n && Fe(Dr(e, L, L, 0, 0, o, l, D, o, R = [], b), s), o, s, b, l, n ? R : s);
                    break;
                  default:
                    Je(O, L, L, L, [""], s, 0, l, s);
                }
        }
        h = p = F = 0, g = k = 1, D = O = "", b = d;
        break;
      case 58:
        b = 1 + H(O), F = C;
      default:
        if (g < 1) {
          if (T == 123)
            --g;
          else if (T == 125 && g++ == 0 && Wa() == 125)
            continue;
        }
        switch (O += Le(T), T * g) {
          case 38:
            k = p > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            l[h++] = (H(O) - 1) * k, k = 1;
            break;
          case 64:
            B() === 45 && (O += Ne(U())), P = B(), p = b = H(D = O += Ya(Re())), T++;
            break;
          case 45:
            C === 45 && H(O) == 2 && (g = 0);
        }
    }
  return c;
}
function Dr(e, r, t, n, o, c, d, l, f, h, p) {
  for (var b = o - 1, P = o === 0 ? c : [""], F = ur(P), C = 0, g = 0, J = 0; C < n; ++C)
    for (var k = 0, T = ve(e, b + 1, b = Ja(g = d[C])), D = e; k < F; ++k)
      (D = Vr(g > 0 ? P[k] + " " + T : w(T, /&\f/g, P[k]))) && (f[J++] = D);
  return Ie(e, r, t, o === 0 ? cr : l, f, h, p);
}
function Ha(e, r, t) {
  return Ie(e, r, t, ir, Le(Ia()), ve(e, 2, -2), 0);
}
function Cr(e, r, t, n) {
  return Ie(e, r, t, sr, ve(e, 0, n), ve(e, n + 1, -1), n);
}
function ie(e, r) {
  for (var t = "", n = ur(e), o = 0; o < n; o++)
    t += r(e[o], o, e, r) || "";
  return t;
}
function Ba(e, r, t, n) {
  switch (e.type) {
    case Na:
      if (e.children.length)
        break;
    case Ra:
    case sr:
      return e.return = e.return || e.value;
    case ir:
      return "";
    case Wr:
      return e.return = e.value + "{" + ie(e.children, n) + "}";
    case cr:
      e.value = e.props.join(",");
  }
  return H(t = ie(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function qa(e) {
  var r = ur(e);
  return function(t, n, o, c) {
    for (var d = "", l = 0; l < r; l++)
      d += e[l](t, n, o, c) || "";
    return d;
  };
}
function Za(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Xa(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var Qa = function(r, t, n) {
  for (var o = 0, c = 0; o = c, c = B(), o === 38 && c === 12 && (t[n] = 1), !ge(c); )
    U();
  return ke(r, V);
}, et = function(r, t) {
  var n = -1, o = 44;
  do
    switch (ge(o)) {
      case 0:
        o === 38 && B() === 12 && (t[n] = 1), r[n] += Qa(V - 1, t, n);
        break;
      case 2:
        r[n] += Ne(o);
        break;
      case 4:
        if (o === 44) {
          r[++n] = B() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += Le(o);
    }
  while (o = U());
  return r;
}, rt = function(r, t) {
  return Yr(et(Kr(r), t));
}, _r = /* @__PURE__ */ new WeakMap(), at = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, o = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !_r.get(n)) && !o) {
      _r.set(r, !0);
      for (var c = [], d = rt(t, c), l = n.props, f = 0, h = 0; f < d.length; f++)
        for (var p = 0; p < l.length; p++, h++)
          r.props[h] = c[f] ? d[f].replace(/&\f/g, l[p]) : l[p] + " " + d[f];
    }
  }
}, tt = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, nt = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", ot = function(r) {
  return r.type === "comm" && r.children.indexOf(nt) > -1;
}, it = function(r) {
  return function(t, n, o) {
    if (!(t.type !== "rule" || r.compat)) {
      var c = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (c) {
        for (var d = !!t.parent, l = d ? t.parent.children : (
          // global rule at the root level
          o
        ), f = l.length - 1; f >= 0; f--) {
          var h = l[f];
          if (h.line < t.line)
            break;
          if (h.column < t.column) {
            if (ot(h))
              return;
            break;
          }
        }
        c.forEach(function(p) {
          console.error('The pseudo class "' + p + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + p.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Gr = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, ct = function(r, t) {
  for (var n = r - 1; n >= 0; n--)
    if (!Gr(t[n]))
      return !0;
  return !1;
}, Pr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, st = function(r, t, n) {
  Gr(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Pr(r)) : ct(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Pr(r)));
};
function Hr(e, r) {
  switch (za(e, r)) {
    case 5103:
      return E + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return E + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return E + e + je + e + I + e + e;
    case 6828:
    case 4268:
      return E + e + I + e + e;
    case 6165:
      return E + e + I + "flex-" + e + e;
    case 5187:
      return E + e + w(e, /(\w+).+(:[^]+)/, E + "box-$1$2" + I + "flex-$1$2") + e;
    case 5443:
      return E + e + I + "flex-item-" + w(e, /flex-|-self/, "") + e;
    case 4675:
      return E + e + I + "flex-line-pack" + w(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return E + e + I + w(e, "shrink", "negative") + e;
    case 5292:
      return E + e + I + w(e, "basis", "preferred-size") + e;
    case 6060:
      return E + "box-" + w(e, "-grow", "") + E + e + I + w(e, "grow", "positive") + e;
    case 4554:
      return E + w(e, /([^-])(transform)/g, "$1" + E + "$2") + e;
    case 6187:
      return w(w(w(e, /(zoom-|grab)/, E + "$1"), /(image-set)/, E + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return w(e, /(image-set\([^]*)/, E + "$1$`$1");
    case 4968:
      return w(w(e, /(.+:)(flex-)?(.*)/, E + "box-pack:$3" + I + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + E + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return w(e, /(.+)-inline(.+)/, E + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (H(e) - 1 - r > 6)
        switch ($(e, r + 1)) {
          case 109:
            if ($(e, r + 4) !== 45)
              break;
          case 102:
            return w(e, /(.+:)(.+)-([^]+)/, "$1" + E + "$2-$3$1" + je + ($(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~rr(e, "stretch") ? Hr(w(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if ($(e, r + 1) !== 115)
        break;
    case 6444:
      switch ($(e, H(e) - 3 - (~rr(e, "!important") && 10))) {
        case 107:
          return w(e, ":", ":" + E) + e;
        case 101:
          return w(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + E + ($(e, 14) === 45 ? "inline-" : "") + "box$3$1" + E + "$2$3$1" + I + "$2box$3") + e;
      }
      break;
    case 5936:
      switch ($(e, r + 11)) {
        case 114:
          return E + e + I + w(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return E + e + I + w(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return E + e + I + w(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return E + e + I + e + e;
  }
  return e;
}
var ut = function(r, t, n, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case sr:
        r.return = Hr(r.value, r.length);
        break;
      case Wr:
        return ie([Te(r, {
          value: w(r.value, "@", "@" + E)
        })], o);
      case cr:
        if (r.length)
          return $a(r.props, function(c) {
            switch (La(c, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ie([Te(r, {
                  props: [w(c, /:(read-\w+)/, ":" + je + "$1")]
                })], o);
              case "::placeholder":
                return ie([Te(r, {
                  props: [w(c, /:(plac\w+)/, ":" + E + "input-$1")]
                }), Te(r, {
                  props: [w(c, /:(plac\w+)/, ":" + je + "$1")]
                }), Te(r, {
                  props: [w(c, /:(plac\w+)/, I + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, dt = [ut], lt = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(g) {
      var J = g.getAttribute("data-emotion");
      J.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || dt;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var c = {}, d, l = [];
  d = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(g) {
      for (var J = g.getAttribute("data-emotion").split(" "), k = 1; k < J.length; k++)
        c[J[k]] = !0;
      l.push(g);
    }
  );
  var f, h = [at, tt];
  process.env.NODE_ENV !== "production" && h.push(it({
    get compat() {
      return C.compat;
    }
  }), st);
  {
    var p, b = [Ba, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? p.insert(g.return) : g.value && g.type !== ir && p.insert(g.value + "{}"));
    } : Za(function(g) {
      p.insert(g);
    })], P = qa(h.concat(o, b)), F = function(J) {
      return ie(Ga(J), P);
    };
    f = function(J, k, T, D) {
      p = T, process.env.NODE_ENV !== "production" && k.map !== void 0 && (p = {
        insert: function(s) {
          T.insert(s + k.map);
        }
      }), F(J ? J + "{" + k.styles + "}" : k.styles), D && (C.inserted[k.name] = !0);
    };
  }
  var C = {
    key: t,
    sheet: new Fa({
      key: t,
      container: d,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: c,
    registered: {},
    insert: f
  };
  return C.sheet.hydrate(l), C;
}, tr = { exports: {} }, M = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function pt() {
  if (Fr)
    return M;
  Fr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, F = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, J = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function D(s) {
    if (typeof s == "object" && s !== null) {
      var L = s.$$typeof;
      switch (L) {
        case r:
          switch (s = s.type, s) {
            case f:
            case h:
            case n:
            case c:
            case o:
            case b:
              return s;
            default:
              switch (s = s && s.$$typeof, s) {
                case l:
                case p:
                case C:
                case F:
                case d:
                  return s;
                default:
                  return L;
              }
          }
        case t:
          return L;
      }
    }
  }
  function R(s) {
    return D(s) === h;
  }
  return M.AsyncMode = f, M.ConcurrentMode = h, M.ContextConsumer = l, M.ContextProvider = d, M.Element = r, M.ForwardRef = p, M.Fragment = n, M.Lazy = C, M.Memo = F, M.Portal = t, M.Profiler = c, M.StrictMode = o, M.Suspense = b, M.isAsyncMode = function(s) {
    return R(s) || D(s) === f;
  }, M.isConcurrentMode = R, M.isContextConsumer = function(s) {
    return D(s) === l;
  }, M.isContextProvider = function(s) {
    return D(s) === d;
  }, M.isElement = function(s) {
    return typeof s == "object" && s !== null && s.$$typeof === r;
  }, M.isForwardRef = function(s) {
    return D(s) === p;
  }, M.isFragment = function(s) {
    return D(s) === n;
  }, M.isLazy = function(s) {
    return D(s) === C;
  }, M.isMemo = function(s) {
    return D(s) === F;
  }, M.isPortal = function(s) {
    return D(s) === t;
  }, M.isProfiler = function(s) {
    return D(s) === c;
  }, M.isStrictMode = function(s) {
    return D(s) === o;
  }, M.isSuspense = function(s) {
    return D(s) === b;
  }, M.isValidElementType = function(s) {
    return typeof s == "string" || typeof s == "function" || s === n || s === h || s === c || s === o || s === b || s === P || typeof s == "object" && s !== null && (s.$$typeof === C || s.$$typeof === F || s.$$typeof === d || s.$$typeof === l || s.$$typeof === p || s.$$typeof === J || s.$$typeof === k || s.$$typeof === T || s.$$typeof === g);
  }, M.typeOf = D, M;
}
var A = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rr;
function yt() {
  return Rr || (Rr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, d = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, b = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, F = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, J = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function D(y) {
      return typeof y == "string" || typeof y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      y === n || y === h || y === c || y === o || y === b || y === P || typeof y == "object" && y !== null && (y.$$typeof === C || y.$$typeof === F || y.$$typeof === d || y.$$typeof === l || y.$$typeof === p || y.$$typeof === J || y.$$typeof === k || y.$$typeof === T || y.$$typeof === g);
    }
    function R(y) {
      if (typeof y == "object" && y !== null) {
        var fe = y.$$typeof;
        switch (fe) {
          case r:
            var te = y.type;
            switch (te) {
              case f:
              case h:
              case n:
              case c:
              case o:
              case b:
                return te;
              default:
                var ee = te && te.$$typeof;
                switch (ee) {
                  case l:
                  case p:
                  case C:
                  case F:
                  case d:
                    return ee;
                  default:
                    return fe;
                }
            }
          case t:
            return fe;
        }
      }
    }
    var s = f, L = h, O = l, We = d, xe = r, Ve = p, Ue = n, Ee = C, Y = F, q = t, Q = c, we = o, Me = b, ue = !1;
    function Ae(y) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), de(y) || R(y) === f;
    }
    function de(y) {
      return R(y) === h;
    }
    function Oe(y) {
      return R(y) === l;
    }
    function De(y) {
      return R(y) === d;
    }
    function Ce(y) {
      return typeof y == "object" && y !== null && y.$$typeof === r;
    }
    function Ke(y) {
      return R(y) === p;
    }
    function Ye(y) {
      return R(y) === n;
    }
    function le(y) {
      return R(y) === C;
    }
    function pe(y) {
      return R(y) === F;
    }
    function re(y) {
      return R(y) === t;
    }
    function ye(y) {
      return R(y) === c;
    }
    function ae(y) {
      return R(y) === o;
    }
    function Ge(y) {
      return R(y) === b;
    }
    A.AsyncMode = s, A.ConcurrentMode = L, A.ContextConsumer = O, A.ContextProvider = We, A.Element = xe, A.ForwardRef = Ve, A.Fragment = Ue, A.Lazy = Ee, A.Memo = Y, A.Portal = q, A.Profiler = Q, A.StrictMode = we, A.Suspense = Me, A.isAsyncMode = Ae, A.isConcurrentMode = de, A.isContextConsumer = Oe, A.isContextProvider = De, A.isElement = Ce, A.isForwardRef = Ke, A.isFragment = Ye, A.isLazy = le, A.isMemo = pe, A.isPortal = re, A.isProfiler = ye, A.isStrictMode = ae, A.isSuspense = Ge, A.isValidElementType = D, A.typeOf = R;
  }()), A;
}
process.env.NODE_ENV === "production" ? tr.exports = pt() : tr.exports = yt();
var ft = tr.exports, Br = ft, mt = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, ht = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, qr = {};
qr[Br.ForwardRef] = mt;
qr[Br.Memo] = ht;
var bt = !0;
function Tt(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : n += o + " ";
  }), n;
}
var Zr = function(r, t, n) {
  var o = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  bt === !1) && r.registered[o] === void 0 && (r.registered[o] = t.styles);
}, vt = function(r, t, n) {
  Zr(r, t, n);
  var o = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var c = t;
    do
      r.insert(t === c ? "." + o : "", c, r.sheet, !0), c = c.next;
    while (c !== void 0);
  }
};
function gt(e) {
  for (var r = 0, t, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var St = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Nr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, kt = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", xt = /[A-Z]|^ms/g, Xr = /_EMO_([^_]+?)_([^]*?)_EMO_/g, dr = function(r) {
  return r.charCodeAt(1) === 45;
}, Jr = function(r) {
  return r != null && typeof r != "boolean";
}, Qe = /* @__PURE__ */ Xa(function(e) {
  return dr(e) ? e : e.replace(xt, "-$&").toLowerCase();
}), ze = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(Xr, function(n, o, c) {
          return G = {
            name: o,
            styles: c,
            next: G
          }, o;
        });
  }
  return St[r] !== 1 && !dr(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var Et = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, wt = ["normal", "none", "initial", "inherit", "unset"], Mt = ze, At = /^-ms-/, Ot = /-(.)/g, jr = {};
  ze = function(r, t) {
    if (r === "content" && (typeof t != "string" || wt.indexOf(t) === -1 && !Et.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = Mt(r, t);
    return n !== "" && !dr(r) && r.indexOf("-") !== -1 && jr[r] === void 0 && (jr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(At, "ms-").replace(Ot, function(o, c) {
      return c.toUpperCase();
    }) + "?")), n;
  };
}
var Qr = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Se(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(Qr);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return G = {
          name: t.name,
          styles: t.styles,
          next: G
        }, t.name;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            G = {
              name: n.name,
              styles: n.styles,
              next: G
            }, n = n.next;
        var o = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (o += t.map), o;
      }
      return Dt(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var c = G, d = t(e);
        return G = c, Se(e, r, d);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], f = t.replace(Xr, function(p, b, P) {
          var F = "animation" + l.length;
          return l.push("const " + F + " = keyframes`" + P.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + F + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + f + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + f + "`"));
      }
      break;
  }
  if (r == null)
    return t;
  var h = r[t];
  return h !== void 0 ? h : t;
}
function Dt(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var o = 0; o < t.length; o++)
      n += Se(e, r, t[o]) + ";";
  else
    for (var c in t) {
      var d = t[c];
      if (typeof d != "object")
        r != null && r[d] !== void 0 ? n += c + "{" + r[d] + "}" : Jr(d) && (n += Qe(c) + ":" + ze(c, d) + ";");
      else {
        if (c === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(Qr);
        if (Array.isArray(d) && typeof d[0] == "string" && (r == null || r[d[0]] === void 0))
          for (var l = 0; l < d.length; l++)
            Jr(d[l]) && (n += Qe(c) + ":" + ze(c, d[l]) + ";");
        else {
          var f = Se(e, r, d);
          switch (c) {
            case "animation":
            case "animationName": {
              n += Qe(c) + ":" + f + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && c === "undefined" && console.error(kt), n += c + "{" + f + "}";
          }
        }
      }
    }
  return n;
}
var zr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ea;
process.env.NODE_ENV !== "production" && (ea = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, Lr = function(r, t, n) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, c = "";
  G = void 0;
  var d = r[0];
  d == null || d.raw === void 0 ? (o = !1, c += Se(n, t, d)) : (process.env.NODE_ENV !== "production" && d[0] === void 0 && console.error(Nr), c += d[0]);
  for (var l = 1; l < r.length; l++)
    c += Se(n, t, r[l]), o && (process.env.NODE_ENV !== "production" && d[l] === void 0 && console.error(Nr), c += d[l]);
  var f;
  process.env.NODE_ENV !== "production" && (c = c.replace(ea, function(P) {
    return f = P, "";
  })), zr.lastIndex = 0;
  for (var h = "", p; (p = zr.exec(c)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    p[1];
  var b = gt(c) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: b,
    styles: c,
    map: f,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: b,
    styles: c,
    next: G
  };
}, Ct = function(r) {
  return r();
}, _t = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, Pt = _t || Ct, lr = {}.hasOwnProperty, pr = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ lt({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (pr.displayName = "EmotionCacheContext");
pr.Provider;
var Ft = function(r) {
  return /* @__PURE__ */ wa(function(t, n) {
    var o = Ma(pr);
    return r(t, o, n);
  });
}, ra = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (ra.displayName = "EmotionThemeContext");
var $r = function(r) {
  var t = r.split(".");
  return t[t.length - 1];
}, Rt = function(r) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (t || (t = /^([A-Za-z0-9$.]+)@/.exec(r), t))
    return $r(t[1]);
}, Nt = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Jt = function(r) {
  return r.replace(/\$/g, "-");
}, jt = function(r) {
  if (r)
    for (var t = r.split(`
`), n = 0; n < t.length; n++) {
      var o = Rt(t[n]);
      if (o) {
        if (Nt.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Jt(o);
      }
    }
}, nr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", or = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", zt = function(r, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && // check if there is a css declaration
  t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var n = {};
  for (var o in t)
    lr.call(t, o) && (n[o] = t[o]);
  if (n[nr] = r, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var c = jt(new Error().stack);
    c && (n[or] = c);
  }
  return n;
}, Lt = function(r) {
  var t = r.cache, n = r.serialized, o = r.isStringTag;
  return Zr(t, n, o), Pt(function() {
    return vt(t, n, o);
  }), null;
}, aa = /* @__PURE__ */ Ft(function(e, r, t) {
  var n = e.css;
  typeof n == "string" && r.registered[n] !== void 0 && (n = r.registered[n]);
  var o = e[nr], c = [n], d = "";
  typeof e.className == "string" ? d = Tt(r.registered, c, e.className) : e.className != null && (d = e.className + " ");
  var l = Lr(c, void 0, X.useContext(ra));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var f = e[or];
    f && (l = Lr([l, "label:" + f + ";"]));
  }
  d += r.key + "-" + l.name;
  var h = {};
  for (var p in e)
    lr.call(e, p) && p !== "css" && p !== nr && (process.env.NODE_ENV === "production" || p !== or) && (h[p] = e[p]);
  return h.ref = t, h.className = d, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(Lt, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (aa.displayName = "EmotionCssPropInternal");
var $t = aa;
function It(e, r, t) {
  return lr.call(r, "css") ? Or.jsx($t, zt(e, r), t) : Or.jsx(e, r, t);
}
const Wt = {
  typography: {
    copiedToolTip: "Copied",
    copyToolTip: "Copy",
    expandLabel: "Expand"
  },
  timePicker: {
    ok: "OK",
    placeholder: "Select time",
    placeholders: ["Start time", "End time"],
    now: "Now"
  },
  popover: {
    close: "Close"
  },
  empty: {
    noData: "No data"
  },
  pagination: {
    total: "Total {0}",
    page: "Page",
    go: "Go to "
  },
  upload: {
    start: "Start",
    cancel: "Cancel",
    upload: "Upload",
    delete: "Delete",
    preview: "Preview",
    retry: "Click to retry",
    dragTip: "Drag and drop the file",
    selectFile: "Select File",
    beginUpload: "Upload File",
    error: "Failed"
  },
  popConfirm: {
    confirm: "Confirm",
    cancel: "Cancel"
  },
  calendar: {
    year: "Year",
    month: "Month",
    day: "Day",
    today: "today",
    week: "Week",
    Monday: "Mon",
    Tuesday: "Tue",
    Wednesday: "Wed",
    Thursday: "Thu",
    Friday: "Fri",
    Saturday: "Sat",
    Sunday: "Sun",
    January: "Jan",
    February: "Feb",
    March: "Mar",
    April: "Apr",
    May: "May",
    June: "Jun",
    July: "Jul",
    August: "Aug",
    September: "Sep",
    October: "Oct",
    November: "Nov",
    December: "Dec",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Year",
    month: "Month",
    day: "Day",
    today: "Today",
    week: "Week",
    Monday: "Mon",
    Tuesday: "Tue",
    Wednesday: "Wed",
    Thursday: "Thu",
    Friday: "Fri",
    Saturday: "Sat",
    Sunday: "Sun",
    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December",
    okText: "OK",
    nowText: "Now",
    timeText: "Time"
  },
  modal: {
    okText: "OK",
    cancelText: "Cancel"
  },
  drawer: {
    okText: "OK",
    cancelText: "Cancel"
  }
}, Vt = Wt, ta = Aa({
  locale: Vt
});
ta.displayName = "ConfigProviderContext";
let na = {};
function Ut(e) {
  na = {
    ...e
  };
}
function Gt() {
  return na;
}
const Kt = (e) => {
  const { locale: r } = e;
  return Oa(() => {
    Ut({ locale: r });
  }, [r]), It(ta.Provider, { value: { locale: r }, children: e.children });
};
Kt.displayName = "ConfigProvider";
const Ht = {
  typography: {
    copiedToolTip: "已复制",
    copyToolTip: "复制",
    expandLabel: "展开"
  },
  timePicker: {
    ok: "确定",
    placeholder: "请选择时间",
    placeholders: ["开始时间", "结束时间"],
    now: "此刻"
  },
  popover: {
    close: "关闭"
  },
  empty: {
    noData: "暂无数据"
  },
  pagination: {
    total: "共{0}条",
    page: "页",
    go: "前往"
  },
  upload: {
    start: "开始",
    cancel: "取消",
    delete: "删除",
    preview: "预览",
    upload: "上传",
    retry: "点击重试",
    dragTip: "拖拽文件至此处",
    dragHover: "释放文件并开始上传",
    selectFile: "选择文件",
    beginUpload: "开始上传"
  },
  popConfirm: {
    confirm: "确认",
    cancel: "取消"
  },
  calendar: {
    year: "年",
    month: "月",
    day: "日",
    today: "今天",
    week: "周",
    Monday: "周一",
    Tuesday: "周二",
    Wednesday: "周三",
    Thursday: "周四",
    Friday: "周五",
    Saturday: "周六",
    Sunday: "周日",
    January: "一月",
    February: "二月",
    March: "三月",
    April: "四月",
    May: "五月",
    June: "六月",
    July: "七月",
    August: "八月",
    September: "九月",
    October: "十月",
    November: "十一月",
    December: "十二月",
    startDate: "开始日期",
    endDate: "结束日期"
  },
  datePicker: {
    year: "年",
    month: "月",
    day: "日",
    today: "今天",
    week: "周",
    Monday: "周一",
    Tuesday: "周二",
    Wednesday: "周三",
    Thursday: "周四",
    Friday: "周五",
    Saturday: "周六",
    Sunday: "周日",
    January: "一月",
    February: "二月",
    March: "三月",
    April: "四月",
    May: "五月",
    June: "六月",
    July: "七月",
    August: "八月",
    September: "九月",
    October: "十月",
    November: "十一月",
    December: "十二月",
    okText: "确定",
    nowText: "此刻",
    timeText: "选择时间"
  },
  modal: {
    okText: "确定",
    cancelText: "取消"
  },
  drawer: {
    okText: "确定",
    cancelText: "取消"
  }
}, Bt = {
  typography: {
    copiedToolTip: "コピーした",
    copyToolTip: "コピー",
    expandLabel: "拡大"
  },
  timePicker: {
    ok: "もちろん",
    placeholder: "時間を選択してください",
    placeholders: ["開始時間", "終了時間"],
    now: "今"
  },
  popover: {
    close: "閉鎖"
  },
  empty: {
    noData: "データなし"
  },
  pagination: {
    total: "合計{0}個のアイテム",
    page: "ページ",
    go: "に行く"
  },
  upload: {
    start: "始める",
    cancel: "キャンセル",
    delete: "消去",
    preview: "プレビュー",
    retry: "クリックして再試行",
    upload: "アップロード",
    dragTip: "ここにファイルをドラッグ アンド ドロップします",
    dragHover: "ファイルを解放してアップロードを開始します",
    selectFile: "ファイルを選択",
    beginUpload: "アップロードを開始"
  },
  popConfirm: {
    confirm: "確認",
    cancel: "キャンセル"
  },
  calendar: {
    year: "年",
    month: "月",
    day: "日",
    today: "今日",
    week: "週",
    Monday: "月曜日に",
    Tuesday: "火曜日",
    Wednesday: "水曜日",
    Thursday: "木曜日",
    Friday: "金曜日",
    Saturday: "土曜日",
    Sunday: "日曜日",
    January: "1月",
    February: "2月",
    March: "行進",
    April: "4月",
    May: "5月",
    June: "六月",
    July: "7月",
    August: "8月",
    September: "9月",
    October: "10月",
    November: "11月",
    December: "12月",
    startDate: "開始日",
    endDate: "終了日"
  },
  datePicker: {
    year: "年",
    month: "月",
    day: "日",
    today: "今日",
    week: "週",
    Monday: "月曜日に",
    Tuesday: "火曜日",
    Wednesday: "水曜日",
    Thursday: "木曜日",
    Friday: "金曜日",
    Saturday: "土曜日",
    Sunday: "日曜日",
    January: "1月",
    February: "2月",
    March: "行進",
    April: "4月",
    May: "5月",
    June: "六月",
    July: "7月",
    August: "8月",
    September: "9月",
    October: "10月",
    November: "11月",
    December: "12月",
    nowText: "今",
    okText: "もちろん",
    timeText: "時間の選択"
  },
  modal: {
    okText: "もちろん",
    cancelText: "キャンセル"
  },
  drawer: {
    okText: "もちろん",
    cancelText: "キャンセル"
  }
}, qt = {
  typography: {
    copiedToolTip: "복제됨",
    copyToolTip: "복사",
    expandLabel: "펼쳐"
  },
  timePicker: {
    ok: "확정",
    placeholder: "시간을 선택하세요",
    placeholders: ["시작시간", "종료시간"],
    now: "지금 이 순간"
  },
  popover: {
    close: "닫기"
  },
  empty: {
    noData: "현재 데이터가 없습니다"
  },
  pagination: {
    total: "총 {0}개",
    page: "페이지",
    go: "가다"
  },
  upload: {
    start: "시작",
    cancel: "취소",
    delete: "삭제",
    preview: "시사",
    retry: "다시 시도하려면 클릭하세요",
    upload: "업로드",
    dragTip: "파일을 여기로 드래그 앤 드래그",
    dragHover: "파일을 해제하고 업로드 시작",
    selectFile: "파일 선택",
    beginUpload: "업로드 시작"
  },
  popConfirm: {
    confirm: "확인",
    cancel: "취소"
  },
  calendar: {
    year: "년",
    month: "달",
    day: "일",
    today: "오늘",
    week: "주",
    Monday: "월요일",
    Tuesday: "화요일",
    Wednesday: "수요일",
    Thursday: "목요일",
    Friday: "금요일",
    Saturday: "토요일",
    Sunday: "일요일",
    January: "1월",
    February: "2월",
    March: "3월",
    April: "4월",
    May: "5월",
    June: "6월",
    July: "7월",
    August: "8월",
    September: "9월",
    October: "10월",
    November: "11월",
    December: "12월",
    startDate: "시작일",
    endDate: "종료일"
  },
  datePicker: {
    Year: "년",
    Month: "달",
    Day: "일",
    Today: "오늘",
    Week: "주",
    Monday: "월요일",
    Tuesday: "화요일",
    Wednesday: "수요일",
    Thursday: "목요일",
    Friday: "금요일",
    Saturday: "토요일",
    Sunday: "일요일",
    January: "1월",
    February: "2월",
    March: "3월",
    April: "4월",
    May: "5월",
    June: "6월",
    July: "7월",
    August: "8월",
    September: "9월",
    October: "10월",
    November: "11월",
    December: "12월",
    nowText: "지금 이 순간",
    okText: "확정",
    timeText: "시간 선택"
  },
  modal: {
    okText: "확정",
    cancelText: "취소"
  },
  drawer: {
    okText: "확정",
    cancelText: "취소"
  }
}, Zt = {
  typography: {
    copiedToolTip: "Zkopírováno",
    copyToolTip: "Kopírovat",
    expandLabel: "Rozbalit"
  },
  timePicker: {
    ok: "OK",
    placeholder: "Vyberte čas",
    placeholders: ["Čas zahájení", "Čas ukončení"],
    now: "Nyní"
  },
  popover: {
    close: "Zavřít"
  },
  empty: {
    noData: "Žádná data"
  },
  pagination: {
    total: "Celkem {0}",
    page: "Stránka",
    go: "Přejít na "
  },
  upload: {
    start: "Začít",
    cancel: "Zrušit",
    upload: "Nahrát",
    delete: "Vymazat",
    preview: "Náhled",
    retry: "Klikněte pro opakování",
    dragTip: "Přetáhněte soubor",
    selectFile: "Vybrat soubor",
    beginUpload: "Nahrát soubor",
    error: "Selhalo"
  },
  popConfirm: {
    confirm: "Potvrdit",
    cancel: "Zrušit"
  },
  calendar: {
    year: "Rok",
    month: "Měsíc",
    day: "Den",
    today: "dnes",
    week: "Týden",
    Monday: "Mon",
    Tuesday: "Út",
    Wednesday: "Stříl/a",
    Thursday: "Thu",
    Friday: "Pá",
    Saturday: "Skot",
    Sunday: "Slunce",
    January: "leden",
    February: "Únor",
    March: "Mar",
    April: "Vrt",
    May: "Květen",
    June: "leden",
    July: "Červen",
    August: "Srp",
    September: "Zář",
    October: "říjen",
    November: "Lov",
    December: "Pro.",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Rok",
    month: "Měsíc",
    day: "Den",
    today: "Dnes",
    week: "Týden",
    Monday: "Mon",
    Tuesday: "Út",
    Wednesday: "Stříl/a",
    Thursday: "Thu",
    Friday: "Pá",
    Saturday: "Skot",
    Sunday: "Slunce",
    January: "Leden",
    February: "únor",
    March: "Březen",
    April: "duben",
    May: "Květen",
    June: "Červen",
    July: "červenec",
    August: "Srpen",
    September: "Září",
    October: "Říjen",
    November: "Listopad",
    December: "prosinec",
    okText: "OK",
    nowText: "Nyní",
    timeText: "Čas"
  },
  modal: {
    okText: "OK",
    cancelText: "Zrušit"
  },
  drawer: {
    okText: "OK",
    cancelText: "Zrušit"
  }
}, Xt = {
  typography: {
    copiedToolTip: "Kopiert",
    copyToolTip: "Kopieren",
    expandLabel: "Erweitern"
  },
  timePicker: {
    ok: "Ok",
    placeholder: "Zeit auswählen",
    placeholders: ["Startzeit", "Endzeit"],
    now: "Jetzt"
  },
  popover: {
    close: "Schließen"
  },
  empty: {
    noData: "Keine Daten"
  },
  pagination: {
    total: "Gesamt {0}",
    page: "Seite",
    go: "Gehe zu "
  },
  upload: {
    start: "Start",
    cancel: "Abbrechen",
    upload: "Hochladen",
    delete: "Löschen",
    preview: "Vorschau",
    retry: "Zum wiederholen klicken",
    dragTip: "Ziehen und Ablegen der Datei",
    selectFile: "Datei auswählen",
    beginUpload: "Datei hochladen",
    error: "Fehler"
  },
  popConfirm: {
    confirm: "Bestätigen",
    cancel: "Abbrechen"
  },
  calendar: {
    year: "Jahr",
    month: "Monat",
    day: "Tag",
    today: "heute",
    week: "Woche",
    Monday: "Mon",
    Tuesday: "Di",
    Wednesday: "Mi",
    Thursday: "Thu",
    Friday: "Fr",
    Saturday: "Sa",
    Sunday: "Sonne",
    January: "Jörg",
    February: "Feb",
    March: "Mär",
    April: "Apr",
    May: "Mai",
    June: "Juni",
    July: "Jul",
    August: "Aug",
    September: "Sep",
    October: "Okt",
    November: "Nov",
    December: "Dez",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Jahr",
    month: "Monat",
    day: "Tag",
    today: "Heute",
    week: "Woche",
    Monday: "Mon",
    Tuesday: "Di",
    Wednesday: "Mi",
    Thursday: "Thu",
    Friday: "Fr",
    Saturday: "Sa",
    Sunday: "Sonne",
    January: "Januar",
    February: "Februar",
    March: "Marsch",
    April: "Ascherz",
    May: "Mai",
    June: "Juni",
    July: "Juli",
    August: "Luciano",
    September: "September",
    October: "Oktober",
    November: "November",
    December: "Dezember",
    okText: "Ok",
    nowText: "Jetzt",
    timeText: "Zeit"
  },
  modal: {
    okText: "Ok",
    cancelText: "Abbrechen"
  },
  drawer: {
    okText: "Ok",
    cancelText: "Abbrechen"
  }
}, Qt = {
  typography: {
    copiedToolTip: "Kopieret",
    copyToolTip: "Kopiér",
    expandLabel: "Udvid"
  },
  timePicker: {
    ok: "Ok",
    placeholder: "Vælg tid",
    placeholders: ["Start tid", "Slut tid"],
    now: "Nu"
  },
  popover: {
    close: "Luk"
  },
  empty: {
    noData: "Ingen data"
  },
  pagination: {
    total: "I alt {0}",
    page: "Side",
    go: "Gå til "
  },
  upload: {
    start: "Start",
    cancel: "Annuller",
    upload: "Upload",
    delete: "Slet",
    preview: "Eksempelvisning",
    retry: "Klik for at prøve igen",
    dragTip: "Træk og slip filen",
    selectFile: "Vælg Fil",
    beginUpload: "Upload Fil",
    error: "Mislykkedes"
  },
  popConfirm: {
    confirm: "Bekræft",
    cancel: "Annuller"
  },
  calendar: {
    year: "År",
    month: "Måned",
    day: "Dag",
    today: "i dag",
    week: "Uge",
    Monday: "Mon",
    Tuesday: "Tir",
    Wednesday: "Ons",
    Thursday: "Thu",
    Friday: "Fre",
    Saturday: "Lør",
    Sunday: "Søn",
    January: "Jan",
    February: "Feb",
    March: "Mar.",
    April: "April",
    May: "Maj",
    June: "Juni",
    July: "Juli",
    August: "Aug.",
    September: "Sep.",
    October: "Okt",
    November: "Nov.",
    December: "Dec.",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "År",
    month: "Måned",
    day: "Dag",
    today: "Idag",
    week: "Uge",
    Monday: "Mon",
    Tuesday: "Tir",
    Wednesday: "Ons",
    Thursday: "Thu",
    Friday: "Fre",
    Saturday: "Lør",
    Sunday: "Søn",
    January: "Januar",
    February: "Februar",
    March: "Marts",
    April: "April",
    May: "Maj",
    June: "Juni",
    July: "Juli",
    August: "August",
    September: "September",
    October: "Oktober",
    November: "November",
    December: "December",
    okText: "Ok",
    nowText: "Nu",
    timeText: "Tid"
  },
  modal: {
    okText: "Ok",
    cancelText: "Annuller"
  },
  drawer: {
    okText: "Ok",
    cancelText: "Annuller"
  }
}, en = {
  typography: {
    copiedToolTip: "Copiado",
    copyToolTip: "Copiar",
    expandLabel: "Expandir"
  },
  timePicker: {
    ok: "Ok",
    placeholder: "Seleccionar hora",
    placeholders: ["Hora de inicio", "Hora de fin"],
    now: "Ahora"
  },
  popover: {
    close: "Cerrar"
  },
  empty: {
    noData: "Sin datos"
  },
  pagination: {
    total: "Total {0}",
    page: "Pgina",
    go: "Ir a "
  },
  upload: {
    start: "Comenzar",
    cancel: "Cancelar",
    upload: "Subir",
    delete: "Eliminar",
    preview: "Vista previa",
    retry: "Clic para reintentar",
    dragTip: "Arrastra y suelta el archivo",
    selectFile: "Seleccionar archivo",
    beginUpload: "Subir archivo",
    error: "Fallo"
  },
  popConfirm: {
    confirm: "Confirmar",
    cancel: "Cancelar"
  },
  calendar: {
    year: "Año",
    month: "Mes",
    day: "Día",
    today: "hoy",
    week: "Semana",
    Monday: "Mon",
    Tuesday: "Tue",
    Wednesday: "Mié",
    Thursday: "Thu",
    Friday: "Vie",
    Saturday: "Sáb",
    Sunday: "Sol",
    January: "Ene",
    February: "Feb",
    March: "Mar",
    April: "Abril",
    May: "Mayo",
    June: "Jun",
    July: "Jul",
    August: "Ago",
    September: "Septiembre",
    October: "Oct",
    November: "Nov",
    December: "Dic",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Año",
    month: "Mes",
    day: "Día",
    today: "Hoy",
    week: "Semana",
    Monday: "Mon",
    Tuesday: "Tue",
    Wednesday: "Mié",
    Thursday: "Thu",
    Friday: "Vie",
    Saturday: "Sáb",
    Sunday: "Sol",
    January: "Enero",
    February: "Febrero",
    March: "Marzo",
    April: "Abril",
    May: "Mayo",
    June: "Junio",
    July: "Julio",
    August: "Agosto",
    September: "Septiembre",
    October: "Octubre",
    November: "Noviembre",
    December: "Diciembre",
    okText: "Ok",
    nowText: "Ahora",
    timeText: "Hora"
  },
  modal: {
    okText: "Ok",
    cancelText: "Cancelar"
  },
  drawer: {
    okText: "Ok",
    cancelText: "Cancelar"
  }
}, rn = {
  typography: {
    copiedToolTip: "Αντιγράφηκε",
    copyToolTip: "Αντιγραφή",
    expandLabel: "Ανάπτυξη"
  },
  timePicker: {
    ok: "Εντάξει",
    placeholder: "Επιλογή ώρας",
    placeholders: ["Ώρα έναρξης", "Ώρα λήξης"],
    now: "Τώρα"
  },
  popover: {
    close: "Κλείσιμο"
  },
  empty: {
    noData: "Δεν υπάρχουν δεδομένα"
  },
  pagination: {
    total: "Σύνολο {0}",
    page: "Σελίδα",
    go: "Μετάβαση σε "
  },
  upload: {
    start: "Έναρξη",
    cancel: "Ακύρωση",
    upload: "Ανέβασμα",
    delete: "Διαγραφή",
    preview: "Προεπισκόπηση",
    retry: "Κλικ για επανάληψη",
    dragTip: "Σύρετε και αποθέστε το αρχείο",
    selectFile: "Επιλογή Αρχείου",
    beginUpload: "Μεταφόρτωση Αρχείου",
    error: "Απέτυχε"
  },
  popConfirm: {
    confirm: "Επιβεβαίωση",
    cancel: "Ακύρωση"
  },
  calendar: {
    year: "Έτος",
    month: "Μήνας",
    day: "Ημέρα",
    today: "σήμερα",
    week: "Εβδομάδα",
    Monday: "Mon",
    Tuesday: "Τρί",
    Wednesday: "Τετ",
    Thursday: "Thu",
    Friday: "Παρ",
    Saturday: "Σαβ",
    Sunday: "Κυρ",
    January: "Ιαν",
    February: "Φεβ",
    March: "Μαρ",
    April: "Απρ",
    May: "Μάιος",
    June: "Ιουν",
    July: "Ιουλ",
    August: "Αυγ",
    September: "Σεπ",
    October: "Οκτ",
    November: "Νοε",
    December: "Δεκ",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Έτος",
    month: "Μήνας",
    day: "Ημέρα",
    today: "Σήμερα",
    week: "Εβδομάδα",
    Monday: "Mon",
    Tuesday: "Τρί",
    Wednesday: "Τετ",
    Thursday: "Thu",
    Friday: "Παρ",
    Saturday: "Σαβ",
    Sunday: "Κυρ",
    January: "Ιανουάριος",
    February: "Φεβρουάριος",
    March: "Μάρτιος",
    April: "Απριλίου",
    May: "Μάιος",
    June: "Ιουνίου",
    July: "Ιούλιος",
    August: "Αύγουστος",
    September: "Σεπτέμβριος",
    October: "Οκτώβριος",
    November: "Νοέμβριος",
    December: "Δεκέμβριος",
    okText: "Εντάξει",
    nowText: "Τώρα",
    timeText: "Ώρα"
  },
  modal: {
    okText: "Εντάξει",
    cancelText: "Ακύρωση"
  },
  drawer: {
    okText: "Εντάξει",
    cancelText: "Ακύρωση"
  }
}, an = {
  typography: {
    copiedToolTip: "Kopioitu",
    copyToolTip: "Kopioi",
    expandLabel: "Laajenna"
  },
  timePicker: {
    ok: "Ok",
    placeholder: "Valitse aika",
    placeholders: ["Aloitus aika", "Loppu aika"],
    now: "Nyt"
  },
  popover: {
    close: "Sulje"
  },
  empty: {
    noData: "Ei tietoja"
  },
  pagination: {
    total: "Yhteensä {0}",
    page: "Sivu",
    go: "Siirry kohteeseen "
  },
  upload: {
    start: "Aloita",
    cancel: "Peruuta",
    upload: "Lähetä",
    delete: "Poista",
    preview: "Esikatselu",
    retry: "Klikkaa yrittääksesi uudelleen",
    dragTip: "Vedä ja pudota tiedosto",
    selectFile: "Valitse Tiedosto",
    beginUpload: "Lataa Tiedosto",
    error: "Epäonnistui"
  },
  popConfirm: {
    confirm: "Vahvista",
    cancel: "Peruuta"
  },
  calendar: {
    year: "Vuosi",
    month: "Kuukausi",
    day: "Päivä",
    today: "tänään",
    week: "Viikko",
    Monday: "Mon",
    Tuesday: "Ti",
    Wednesday: "Ke",
    Thursday: "Thu",
    Friday: "Pe",
    Saturday: "La",
    Sunday: "Su",
    January: "Tammi",
    February: "Helmi",
    March: "Maalis",
    April: "Huhti",
    May: "Toukokuu",
    June: "Kesä",
    July: "Heinä",
    August: "Elo",
    September: "Syys",
    October: "Loka",
    November: "Marras",
    December: "Joulu",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Vuosi",
    month: "Kuukausi",
    day: "Päivä",
    today: "Tänään",
    week: "Viikko",
    Monday: "Mon",
    Tuesday: "Ti",
    Wednesday: "Ke",
    Thursday: "Thu",
    Friday: "Pe",
    Saturday: "La",
    Sunday: "Su",
    January: "Tammikuu",
    February: "Helmikuu",
    March: "Maaliskuu",
    April: "Huhtikuu",
    May: "Toukokuu",
    June: "Kesäkuu",
    July: "Heinäkuu",
    August: "Elokuu",
    September: "Syyskuu",
    October: "Lokakuu",
    November: "Marraskuu",
    December: "Joulukuu",
    okText: "Ok",
    nowText: "Nyt",
    timeText: "Aika"
  },
  modal: {
    okText: "Ok",
    cancelText: "Peruuta"
  },
  drawer: {
    okText: "Ok",
    cancelText: "Peruuta"
  }
}, tn = {
  typography: {
    copiedToolTip: "Copié",
    copyToolTip: "Copie",
    expandLabel: "Agrandir"
  },
  timePicker: {
    ok: "Ok",
    placeholder: "Sélectionnez l'heure",
    placeholders: ["Heure de début", "Heure de fin"],
    now: "Maintenant"
  },
  popover: {
    close: "Fermer"
  },
  empty: {
    noData: "Aucune donnée"
  },
  pagination: {
    total: "Total {0}",
    page: "Page",
    go: "Aller à "
  },
  upload: {
    start: "Début",
    cancel: "Abandonner",
    upload: "Charger",
    delete: "Supprimez",
    preview: "Aperçu",
    retry: "Cliquez pour réessayer",
    dragTip: "Glisser et déposer le fichier",
    selectFile: "Sélectionner un fichier",
    beginUpload: "Charger un fichier",
    error: "Echoué"
  },
  popConfirm: {
    confirm: "Valider",
    cancel: "Abandonner"
  },
  calendar: {
    year: "Année",
    month: "Mois",
    day: "Jour",
    today: "aujourd'hui",
    week: "Semaine",
    Monday: "Mon",
    Tuesday: "Mai",
    Wednesday: "Mer",
    Thursday: "Thu",
    Friday: "Ven",
    Saturday: "Sam",
    Sunday: "Dim",
    January: "Janvier",
    February: "Février",
    March: "Mai",
    April: "Avr",
    May: "Mai",
    June: "Juin",
    July: "Juin",
    August: "Août",
    September: "Sep",
    October: "Oct",
    November: "Nov",
    December: "Déc",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Année",
    month: "Mois",
    day: "Jour",
    today: "Aujourd'hui",
    week: "Semaine",
    Monday: "Mon",
    Tuesday: "Mai",
    Wednesday: "Mer",
    Thursday: "Thu",
    Friday: "Ven",
    Saturday: "Sam",
    Sunday: "Dim",
    January: "Janvier",
    February: "Février",
    March: "Marche",
    April: "Avril",
    May: "Mai",
    June: "Juin",
    July: "Juillet",
    August: "Août",
    September: "Septembre",
    October: "Octobre",
    November: "Novembre",
    December: "Décembre",
    okText: "Ok",
    nowText: "Maintenant",
    timeText: "Date et heure"
  },
  modal: {
    okText: "Ok",
    cancelText: "Abandonner"
  },
  drawer: {
    okText: "Ok",
    cancelText: "Abandonner"
  }
}, nn = {
  typography: {
    copiedToolTip: "Copiato",
    copyToolTip: "Copia",
    expandLabel: "Espandi"
  },
  timePicker: {
    ok: "OK",
    placeholder: "Seleziona ora",
    placeholders: ["Ora di inizio", "Ora di fine"],
    now: "Ora"
  },
  popover: {
    close: "Chiudi"
  },
  empty: {
    noData: "Nessun dato"
  },
  pagination: {
    total: "Totale {0}",
    page: "Pagina",
    go: "Vai a "
  },
  upload: {
    start: "Inizia",
    cancel: "Annulla",
    upload: "Carica",
    delete: "Elimina",
    preview: "Anteprima",
    retry: "Clicca per riprovare",
    dragTip: "Trascina e rilascia il file",
    selectFile: "Seleziona File",
    beginUpload: "Carica File",
    error: "Fallito"
  },
  popConfirm: {
    confirm: "Conferma",
    cancel: "Annulla"
  },
  calendar: {
    year: "Anno",
    month: "Mese",
    day: "Giorno",
    today: "oggi",
    week: "Settimana",
    Monday: "Mon",
    Tuesday: "Mar",
    Wednesday: "Mer",
    Thursday: "Thu",
    Friday: "Ven",
    Saturday: "Sab",
    Sunday: "Sun",
    January: "Gen",
    February: "Feb",
    March: "Mar",
    April: "Apr",
    May: "Maggio",
    June: "Giu",
    July: "Lug",
    August: "Ago",
    September: "Set",
    October: "Ott",
    November: "Nov",
    December: "Dic",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Anno",
    month: "Mese",
    day: "Giorno",
    today: "Oggi",
    week: "Settimana",
    Monday: "Mon",
    Tuesday: "Mar",
    Wednesday: "Mer",
    Thursday: "Thu",
    Friday: "Ven",
    Saturday: "Sab",
    Sunday: "Sun",
    January: "Gennaio",
    February: "Febbraio",
    March: "Marzo",
    April: "Aprile",
    May: "Maggio",
    June: "Giugno",
    July: "Luglio",
    August: "Agosto",
    September: "Settembre",
    October: "Ottobre",
    November: "Novembre",
    December: "Dicembre",
    okText: "OK",
    nowText: "Ora",
    timeText: "Tempo"
  },
  modal: {
    okText: "OK",
    cancelText: "Annulla"
  },
  drawer: {
    okText: "OK",
    cancelText: "Annulla"
  }
}, on = {
  typography: {
    copiedToolTip: "Gekoppeld",
    copyToolTip: "Kopiëren",
    expandLabel: "Uitklappen"
  },
  timePicker: {
    ok: "Ok",
    placeholder: "Selecteer tijd",
    placeholders: ["Start Time", "Einde tijd"],
    now: "Nu"
  },
  popover: {
    close: "Afsluiten"
  },
  empty: {
    noData: "Geen gegevens"
  },
  pagination: {
    total: "Totaal {0}",
    page: "Pagina",
    go: "Ga naar "
  },
  upload: {
    start: "Beginnen",
    cancel: "annuleren",
    upload: "Uploaden",
    delete: "Verwijderen",
    preview: "Voorvertoning",
    retry: "Klik om opnieuw te proberen",
    dragTip: "Bestand slepen en neerzetten",
    selectFile: "Bestand selecteren",
    beginUpload: "Bestand uploaden",
    error: "Mislukt"
  },
  popConfirm: {
    confirm: "Bevestigen",
    cancel: "annuleren"
  },
  calendar: {
    year: "jaar",
    month: "maand",
    day: "dag",
    today: "vandaag",
    week: "week",
    Monday: "Mon",
    Tuesday: "di",
    Wednesday: "woe",
    Thursday: "Thu",
    Friday: "vr",
    Saturday: "za",
    Sunday: "zo",
    January: "jan",
    February: "feb",
    March: "maa",
    April: "apr",
    May: "mei",
    June: "jun",
    July: "jul",
    August: "aug",
    September: "sep",
    October: "okt",
    November: "nov",
    December: "dec",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "jaar",
    month: "maand",
    day: "dag",
    today: "vandaag",
    week: "week",
    Monday: "Mon",
    Tuesday: "di",
    Wednesday: "woe",
    Thursday: "Thu",
    Friday: "vr",
    Saturday: "za",
    Sunday: "zo",
    January: "januari",
    February: "februari",
    March: "maart",
    April: "april",
    May: "mei",
    June: "juni",
    July: "juli",
    August: "augustus",
    September: "september",
    October: "oktober",
    November: "november",
    December: "december",
    okText: "Ok",
    nowText: "Nu",
    timeText: "Tijd"
  },
  modal: {
    okText: "Ok",
    cancelText: "annuleren"
  },
  drawer: {
    okText: "Ok",
    cancelText: "annuleren"
  }
}, cn = {
  typography: {
    copiedToolTip: "Kopiert",
    copyToolTip: "Kopier",
    expandLabel: "Utvid"
  },
  timePicker: {
    ok: "Ok",
    placeholder: "Velg tid",
    placeholders: ["Start tidspunkt", "Slutt tid"],
    now: "Nå"
  },
  popover: {
    close: "Lukk"
  },
  empty: {
    noData: "Ingen data"
  },
  pagination: {
    total: "Totalt {0}",
    page: "Side",
    go: "Gå til "
  },
  upload: {
    start: "Begynn",
    cancel: "Avbryt",
    upload: "Last opp",
    delete: "Slett",
    preview: "Forhåndsvisning",
    retry: "Klikk for å prøve igjen",
    dragTip: "Dra og slipp filen",
    selectFile: "Velg fil",
    beginUpload: "Last opp fil",
    error: "Mislyktes"
  },
  popConfirm: {
    confirm: "Bekreft",
    cancel: "Avbryt"
  },
  calendar: {
    year: "År",
    month: "Måned",
    day: "Dag",
    today: "i dag",
    week: "Uke",
    Monday: "Mon",
    Tuesday: "Tir",
    Wednesday: "Ons",
    Thursday: "Thu",
    Friday: "Fre",
    Saturday: "Lør",
    Sunday: "Søn",
    January: "jan",
    February: "feb",
    March: "mar",
    April: "apr",
    May: "Mai",
    June: "jun",
    July: "jul",
    August: "aug",
    September: "sep",
    October: "Okt",
    November: "nov",
    December: "Des",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "År",
    month: "Måned",
    day: "Dag",
    today: "Idag",
    week: "Uke",
    Monday: "Mon",
    Tuesday: "Tir",
    Wednesday: "Ons",
    Thursday: "Thu",
    Friday: "Fre",
    Saturday: "Lør",
    Sunday: "Søn",
    January: "Januar",
    February: "Februar",
    March: "Mars",
    April: "april",
    May: "Mai",
    June: "Juni",
    July: "Juli",
    August: "august",
    September: "september",
    October: "oktober",
    November: "november",
    December: "Desember",
    okText: "Ok",
    nowText: "Nå",
    timeText: "Tid"
  },
  modal: {
    okText: "Ok",
    cancelText: "Avbryt"
  },
  drawer: {
    okText: "Ok",
    cancelText: "Avbryt"
  }
}, sn = {
  typography: {
    copiedToolTip: "Skopiowano",
    copyToolTip: "Kopiuj",
    expandLabel: "Rozwiń"
  },
  timePicker: {
    ok: "OK",
    placeholder: "Wybierz czas",
    placeholders: ["Godzina rozpoczęcia", "Czas zakończenia"],
    now: "Teraz"
  },
  popover: {
    close: "Zamknij"
  },
  empty: {
    noData: "Brak danych"
  },
  pagination: {
    total: "Łącznie {0}",
    page: "Strona",
    go: "Przejdź do "
  },
  upload: {
    start: "Rozpocznij",
    cancel: "Anuluj",
    upload: "Prześlij",
    delete: "Usuń",
    preview: "Podgląd",
    retry: "Kliknij, aby spróbować ponownie",
    dragTip: "Przeciągnij i upuść plik",
    selectFile: "Wybierz plik",
    beginUpload: "Prześlij plik",
    error: "Niepowodzenie"
  },
  popConfirm: {
    confirm: "Potwierdź",
    cancel: "Anuluj"
  },
  calendar: {
    year: "W związku z tym Komisja stwierdza, że środek 1 stanowi pomoc państwa w rozumieniu art. 107 ust. 1 Traktatu.",
    month: "Miesiąc",
    day: "Dzień",
    today: "dziś",
    week: "Tydzień",
    Monday: "Mon",
    Tuesday: "Wtyczka",
    Wednesday: "Śr",
    Thursday: "Thu",
    Friday: "Pt",
    Saturday: "Sat",
    Sunday: "Słońce",
    January: "Styczeń",
    February: "Luty",
    March: "Mar",
    April: "Krok",
    May: "Maj",
    June: "Czerwony",
    July: "Lipiec",
    August: "Sierpień",
    September: "Wrz.",
    October: "Paź",
    November: "Lip.",
    December: "Grudzień",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "W związku z tym Komisja stwierdza, że środek 1 stanowi pomoc państwa w rozumieniu art. 107 ust. 1 Traktatu.",
    month: "Miesiąc",
    day: "Dzień",
    today: "Dziś",
    week: "Tydzień",
    Monday: "Mon",
    Tuesday: "Wtyczka",
    Wednesday: "Śr",
    Thursday: "Thu",
    Friday: "Pt",
    Saturday: "Sat",
    Sunday: "Słońce",
    January: "Styczeń",
    February: "Luty",
    March: "Marzec",
    April: "Kwiecień",
    May: "Maj",
    June: "Czerwiec",
    July: "Lipiec",
    August: "Sierpień",
    September: "Wrzesień",
    October: "Październik",
    November: "Listopad",
    December: "Grudzień",
    okText: "OK",
    nowText: "Teraz",
    timeText: "Czas"
  },
  modal: {
    okText: "OK",
    cancelText: "Anuluj"
  },
  drawer: {
    okText: "OK",
    cancelText: "Anuluj"
  }
}, un = {
  typography: {
    copiedToolTip: "Copiado",
    copyToolTip: "copiar",
    expandLabel: "Expandir"
  },
  timePicker: {
    ok: "Certo",
    placeholder: "Selecionar horário",
    placeholders: ["Horário de início", "Hora de término"],
    now: "agora"
  },
  popover: {
    close: "FECHAR"
  },
  empty: {
    noData: "Não há dados"
  },
  pagination: {
    total: "Total de {0}",
    page: "Página",
    go: "Ir para "
  },
  upload: {
    start: "Iniciar",
    cancel: "cancelar",
    upload: "Transferir",
    delete: "excluir",
    preview: "Pré-visualizar",
    retry: "Clique para tentar novamente",
    dragTip: "Arraste e solte o arquivo",
    selectFile: "Selecione o arquivo",
    beginUpload: "Enviar Arquivo",
    error: "Falhou"
  },
  popConfirm: {
    confirm: "Confirmar",
    cancel: "cancelar"
  },
  calendar: {
    year: "ano",
    month: "Mês",
    day: "dia",
    today: "Hoje",
    week: "semana",
    Monday: "Mon",
    Tuesday: "Terça",
    Wednesday: "qua",
    Thursday: "Thu",
    Friday: "Sexta",
    Saturday: "Sábado",
    Sunday: "dom",
    January: "jan",
    February: "fev",
    March: "Mar.",
    April: "Abr.",
    May: "maio",
    June: "Jun.",
    July: "Jul.",
    August: "ago",
    September: "set",
    October: "out",
    November: "nov",
    December: "dez",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "ano",
    month: "Mês",
    day: "dia",
    today: "hoje",
    week: "semana",
    Monday: "Mon",
    Tuesday: "Terça",
    Wednesday: "qua",
    Thursday: "Thu",
    Friday: "Sexta",
    Saturday: "Sábado",
    Sunday: "dom",
    January: "janeiro",
    February: "fevereiro",
    March: "março",
    April: "abril",
    May: "maio",
    June: "junho",
    July: "julho",
    August: "agosto",
    September: "setembro",
    October: "outubro",
    November: "novembro",
    December: "dezembro",
    okText: "Certo",
    nowText: "agora",
    timeText: "Horário"
  },
  modal: {
    okText: "Certo",
    cancelText: "cancelar"
  },
  drawer: {
    okText: "Certo",
    cancelText: "cancelar"
  }
}, dn = {
  typography: {
    copiedToolTip: "Copiat",
    copyToolTip: "Copiază",
    expandLabel: "Extinde"
  },
  timePicker: {
    ok: "Ok",
    placeholder: "Selectați ora",
    placeholders: ["Ora de începere", "Ora de încheiere"],
    now: "Acum"
  },
  popover: {
    close: "Inchide"
  },
  empty: {
    noData: "Nu există date"
  },
  pagination: {
    total: "Total {0}",
    page: "Pagină",
    go: "Mergi la "
  },
  upload: {
    start: "Pornire",
    cancel: "Anulează",
    upload: "Incarca",
    delete: "Ștergere",
    preview: "Previzualizare",
    retry: "Click pentru a reîncerca",
    dragTip: "Trageți și plasați fișierul",
    selectFile: "Selectaţi fişierul",
    beginUpload: "Incarca fisier",
    error: "Eșuat"
  },
  popConfirm: {
    confirm: "Confirmare",
    cancel: "Anulează"
  },
  calendar: {
    year: "An",
    month: "Lună",
    day: "Zi",
    today: "astăzi",
    week: "Saptamana",
    Monday: "Mon",
    Tuesday: "Ma",
    Wednesday: "Miercuri",
    Thursday: "Thu",
    Friday: "Vin",
    Saturday: "Sâm",
    Sunday: "Soare",
    January: "Ian",
    February: "Feb",
    March: "Mar",
    April: "Apr",
    May: "Mai",
    June: "Iun",
    July: "Iul",
    August: "Aug",
    September: "Sep",
    October: "Octombrie",
    November: "Nr",
    December: "Decembrie",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "An",
    month: "Lună",
    day: "Zi",
    today: "Astăzi",
    week: "Saptamana",
    Monday: "Mon",
    Tuesday: "Ma",
    Wednesday: "Miercuri",
    Thursday: "Thu",
    Friday: "dddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddv",
    Saturday: "Sâm",
    Sunday: "Soare",
    January: "Ianuarie",
    February: "Februarie",
    March: "Martie",
    April: "aprilie",
    May: "Mai",
    June: "Iunie",
    July: "Iulie",
    August: "august",
    September: "Septembrie",
    October: "Octombrie",
    November: "Noiembrie",
    December: "Decembrie",
    okText: "Ok",
    nowText: "Acum",
    timeText: "Timp"
  },
  modal: {
    okText: "Ok",
    cancelText: "Anulează"
  },
  drawer: {
    okText: "Ok",
    cancelText: "Anulează"
  }
}, ln = {
  typography: {
    copiedToolTip: "Скопировано",
    copyToolTip: "Копировать",
    expandLabel: "Развернуть"
  },
  timePicker: {
    ok: "ОК",
    placeholder: "Выберите время",
    placeholders: ["Время начала", "Время окончания"],
    now: "Сейчас"
  },
  popover: {
    close: "Закрыть"
  },
  empty: {
    noData: "Нет данных"
  },
  pagination: {
    total: "Всего {0}",
    page: "Страница",
    go: "Перейти к "
  },
  upload: {
    start: "Начать",
    cancel: "Отмена",
    upload: "Выгрузить",
    delete: "Удалить",
    preview: "Предпросмотр",
    retry: "Повторить попытку",
    dragTip: "Перетащите файл",
    selectFile: "Выбрать файл",
    beginUpload: "Загрузить файл",
    error: "Неудачный"
  },
  popConfirm: {
    confirm: "Подтвердить",
    cancel: "Отмена"
  },
  calendar: {
    year: "Год",
    month: "Месяц",
    day: "День",
    today: "сегодня",
    week: "Неделя",
    Monday: "Mon",
    Tuesday: "Вт",
    Wednesday: "Ср",
    Thursday: "Thu",
    Friday: "Пт",
    Saturday: "Сб",
    Sunday: "Вс",
    January: "Ян",
    February: "Февраль",
    March: "Мар",
    April: "Апр",
    May: "Май",
    June: "Июнь",
    July: "Июль",
    August: "Авг",
    September: "Сен",
    October: "Окт",
    November: "Ноя",
    December: "Дек",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Год",
    month: "Месяц",
    day: "День",
    today: "Сегодня",
    week: "Неделя",
    Monday: "Mon",
    Tuesday: "Вт",
    Wednesday: "Ср",
    Thursday: "Thu",
    Friday: "Пт",
    Saturday: "Сб",
    Sunday: "Вс",
    January: "Январь",
    February: "Февраль",
    March: "Март",
    April: "Апрель",
    May: "Май",
    June: "Июнь",
    July: "Июль",
    August: "Август",
    September: "Сентябрь",
    October: "Октябрь",
    November: "Ноябрь",
    December: "Декабрь",
    okText: "ОК",
    nowText: "Сейчас",
    timeText: "Время"
  },
  modal: {
    okText: "ОК",
    cancelText: "Отмена"
  },
  drawer: {
    okText: "ОК",
    cancelText: "Отмена"
  }
}, pn = {
  typography: {
    copiedToolTip: "Kopierad",
    copyToolTip: "Kopiera",
    expandLabel: "Expandera"
  },
  timePicker: {
    ok: "Ok",
    placeholder: "Välj tid",
    placeholders: ["Starttid", "Slut tid"],
    now: "Nu"
  },
  popover: {
    close: "Stäng"
  },
  empty: {
    noData: "Ingen data"
  },
  pagination: {
    total: "Totalt {0}",
    page: "Sida",
    go: "Gå till "
  },
  upload: {
    start: "Starta",
    cancel: "Avbryt",
    upload: "Ladda upp",
    delete: "Radera",
    preview: "Förhandsgranska",
    retry: "Klicka för att försöka igen",
    dragTip: "Dra och släpp filen",
    selectFile: "Välj fil",
    beginUpload: "Ladda upp fil",
    error: "Misslyckades"
  },
  popConfirm: {
    confirm: "Bekräfta",
    cancel: "Avbryt"
  },
  calendar: {
    year: "År",
    month: "Månad",
    day: "Dag",
    today: "idag",
    week: "Vecka",
    Monday: "Mon",
    Tuesday: "Tis",
    Wednesday: "Ons",
    Thursday: "Thu",
    Friday: "Fre",
    Saturday: "Lör",
    Sunday: "Sön",
    January: "jan",
    February: "feb",
    March: "mar",
    April: "apr",
    May: "Maj",
    June: "jun",
    July: "jul",
    August: "aug",
    September: "sep",
    October: "Okt",
    November: "nov",
    December: "dec",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "År",
    month: "Månad",
    day: "Dag",
    today: "Idag",
    week: "Vecka",
    Monday: "Mon",
    Tuesday: "Tis",
    Wednesday: "Ons",
    Thursday: "Thu",
    Friday: "Fre",
    Saturday: "Lör",
    Sunday: "Sön",
    January: "Januari",
    February: "Februari",
    March: "Mars",
    April: "april",
    May: "Maj",
    June: "Juni",
    July: "Juli",
    August: "Augusti",
    September: "september",
    October: "Oktober",
    November: "november",
    December: "december",
    okText: "Ok",
    nowText: "Nu",
    timeText: "Tid"
  },
  modal: {
    okText: "Ok",
    cancelText: "Avbryt"
  },
  drawer: {
    okText: "Ok",
    cancelText: "Avbryt"
  }
}, yn = {
  typography: {
    copiedToolTip: "Скопійовано",
    copyToolTip: "Копія",
    expandLabel: "Розгорнути"
  },
  timePicker: {
    ok: "Гаразд",
    placeholder: "Оберіть час",
    placeholders: ["Час початку", "Час завершення"],
    now: "Зараз"
  },
  popover: {
    close: "Закрити"
  },
  empty: {
    noData: "Немає даних"
  },
  pagination: {
    total: "Всього {0}",
    page: "Сторінка",
    go: "Перейти до "
  },
  upload: {
    start: "Старт",
    cancel: "Скасувати",
    upload: "Вивантажити",
    delete: "Видалити",
    preview: "Прев'ю",
    retry: "Натисніть, щоб повторити",
    dragTip: "Перетягніть файл",
    selectFile: "Виберіть файл",
    beginUpload: "Завантажити файл",
    error: "Не вдалося"
  },
  popConfirm: {
    confirm: "Підтвердити",
    cancel: "Скасувати"
  },
  calendar: {
    year: "Рік",
    month: "Місяць",
    day: "День",
    today: "сьогодні",
    week: "Тижні",
    Monday: "Mon",
    Tuesday: "Вт",
    Wednesday: "Ср",
    Thursday: "Thu",
    Friday: "Пт",
    Saturday: "Сб",
    Sunday: "НД",
    January: "Січ",
    February: "Лют",
    March: "Бер",
    April: "Кві",
    May: "Травень",
    June: "Чер",
    July: "Лип",
    August: "Сер",
    September: "Вер",
    October: "Жов",
    November: "Лис",
    December: "Гру",
    startDate: "StartDate",
    endDate: "EndDate"
  },
  datePicker: {
    year: "Рік",
    month: "Місяць",
    day: "День",
    today: "Сьогодні",
    week: "Тижні",
    Monday: "Mon",
    Tuesday: "Вт",
    Wednesday: "Ср",
    Thursday: "Thu",
    Friday: "Пт",
    Saturday: "Сб",
    Sunday: "НД",
    January: "Січень",
    February: "Лютий",
    March: "Березень",
    April: "Квітень",
    May: "Травень",
    June: "Червень",
    July: "Липень",
    August: "Серпень",
    September: "Вересні",
    October: "Жовтень",
    November: "Листопад",
    December: "Грудень",
    okText: "Гаразд",
    nowText: "Зараз",
    timeText: "Час"
  },
  modal: {
    okText: "Гаразд",
    cancelText: "Скасувати"
  },
  drawer: {
    okText: "Гаразд",
    cancelText: "Скасувати"
  }
}, fn = {
  typography: {
    copiedToolTip: "已複製",
    copyToolTip: "複製",
    expandLabel: "展開"
  },
  timePicker: {
    ok: "確定",
    placeholder: "選擇時間",
    placeholders: ["開始時間", "結束時間"],
    now: "現在"
  },
  popover: {
    close: "關閉"
  },
  empty: {
    noData: "暫無數據"
  },
  pagination: {
    total: "共 {0} 條",
    page: "頁",
    go: "前往第"
  },
  upload: {
    start: "開始上傳",
    cancel: "取消",
    upload: "上傳",
    delete: "刪除",
    preview: "預覽",
    retry: "點擊重試",
    dragTip: "將文件拖到此處上傳",
    selectFile: "選擇文件",
    beginUpload: "開始上傳",
    error: "上傳失敗"
  },
  popConfirm: {
    confirm: "確定",
    cancel: "取消"
  },
  calendar: {
    year: "年",
    month: "月",
    day: "日",
    today: "今天",
    week: "周",
    Monday: "週一",
    Tuesday: "週二",
    Wednesday: "週三",
    Thursday: "週四",
    Friday: "週五",
    Saturday: "週六",
    Sunday: "週日",
    January: "一月",
    February: "二月",
    March: "三月",
    April: "四月",
    May: "五月",
    June: "六月",
    July: "七月",
    August: "八月",
    September: "九月",
    October: "十月",
    November: "十一月",
    December: "十二月",
    startDate: "開始日期",
    endDate: "結束日期"
  },
  datePicker: {
    year: "年",
    month: "月",
    day: "日",
    today: "今天",
    week: "周",
    Monday: "週一",
    Tuesday: "週二",
    Wednesday: "週三",
    Thursday: "週四",
    Friday: "週五",
    Saturday: "週六",
    Sunday: "週日",
    January: "一月",
    February: "二月",
    March: "三月",
    April: "四月",
    May: "五月",
    June: "六月",
    July: "七月",
    August: "八月",
    September: "九月",
    October: "十月",
    November: "十一月",
    December: "十二月",
    okText: "確定",
    nowText: "現在",
    timeText: "時間"
  },
  modal: {
    okText: "確定",
    cancelText: "取消"
  },
  drawer: {
    okText: "確定",
    cancelText: "取消"
  }
};
export {
  Kt as ConfigProvider,
  ta as ConfigProviderContext,
  Zt as csCS,
  Qt as daDK,
  Xt as deDE,
  Vt as def,
  rn as elGR,
  Wt as enUS,
  en as esES,
  an as fiFI,
  tn as frFR,
  Gt as getConfigProviderProps,
  nn as itIT,
  Bt as jaJP,
  qt as koKR,
  on as nlNL,
  cn as noNO,
  sn as plPL,
  un as ptPT,
  dn as roRO,
  ln as ruRU,
  Ut as setConfigProviderProps,
  pn as svSE,
  yn as ukUA,
  Ht as zhCN,
  fn as zhTW
};
//# sourceMappingURL=index.js.map
